export default "assets/images/3131423d782cd3ea89a81247065e7f9d.png";